module.exports = "/img/team-member-2.f945949d.png";